export default {
    activateuser: {
        headerLabel: 'Integrare utilizator',
        accountActivation: 'Activare cont',
        step1: {
            header: 'Bine ați venit pe platforma noastră!',
            subHeader: 'Alegeți modul în care doriți să vă conectați contul',
            description:
                'Pentru a ușura procesul de autentificare, vă recomandăm să vă conectați contul la cel puțin unul dintre următoarele servicii.',
            OR: 'sau',
            emailAndPassword: 'Folosiți-vă propria adresă de e-mail',
        },
        step2: {
            header: 'Folosiți adresa de e-mail și parola',
            description:
                'Acesta este e-mailul principal care va fi asociat contului dvs. Vă recomandăm să utilizați un e-mail diferit de adresa universității dvs. pentru a vă păstra accesul la datele dvs. după absolvire. Puteți controla cu ușurință ce e-mailuri primiți de la noi în setările contului dvs.',
            invalidEmail: 'E-mail-ul furnizat nu este un e-mail valid.',
            passwordsNotMatch: 'Parolele trebuie să se potrivească',
            passwordDescription01:
                'Pentru a vă asigura securitatea contului, trebuie să setați o nouă parolă. Vă rugăm să creați o parolă care să conțină următoarele:',
            passwordDescription02: 'Minimum 8 caractere',
            passwordDescription03: 'Cel puțin o literă mică (a-z)',
            passwordDescription04: 'Cel puțin o literă mare (A-Z)',
            passwordDescription05: 'Cel puțin un număr sau un simbol special (0-9, !#$ etc.)',
            passwordDescription06: 'Cel puțin 6 caractere unice',
            repeatPassword: 'Repetați parola',
        },
        step3: {
            header: 'Se activează utilizatorul',
            loadingHints: {
                0: 'Se încarcă informațiile utilizatorului',
                1: 'Se pregătește totul pentru dvs.',
                2: 'Noi posibilități se află chiar după colț',
                3: 'Aproape gata!',
            },
            successHeader: 'Contul dvs. este acum pregătit!',
            successSubheader: 'Acum puteți accesa funcții exclusive!',
            errorHeader: 'Nu a fost posibilă activarea contului',
            ifWrongContact:
                'Dacă considerați că acest lucru este greșit, vă rugăm să contactați departamentul de asistență',
            contactForHelp: 'Contactați-ne pentru asistență',
            goBack: 'Mergeți înapoi',
        },
    },
    assessments: {
        general: {
            checkMyProgress: 'Verificare progres',
            getStarted: 'Începeți!',
            getToKnowYourself: 'Cunoașteți-vă pe dvs. înșivă',
            getToKnowYourselfBold: 'Cunoașteți-vă pe dvs. <strong>înșivă</strong>',
            getToKnowYourFuture: 'Cunoașteți-vă viitorul',
            getToKnowYourFutureBold: 'Cunoașteți-vă <strong>viitorul</strong>',
            openAssessments: 'Evaluări deschise',
            openAssessment: 'Evaluare deschisă',
            unlock: 'Deblocați testele',
            testYourself: 'Testați-vă',
            takeTheFreeTests: 'Testați-vă gratuit',
            youOwnThisProduct: 'Dețineți acest produs',
            startTest: 'Începeți testul',
            startTests: 'Începeți testele',
            continue: 'Continuați',
            showReport: 'Afișare raport',
            showYourReports: 'Afișarea rapoartelor dvs.',
            showYourReport: 'Afișarea raportului dvs.',
            continueFreeTests: 'Continuați testările gratuite',
            continueTheTest: 'Continuați testul',
            estimatedTime: '~ {min} min',
        },
        landing: {
            section1: {
                title: 'Testați-vă',
                description01:
                    'Bine ați venit la Centrul de Evaluare - acesta este locul de început al călătoriei dvs. profesionale.',
                description02:
                    'Aici puteți să accesați testul de <strong>evaluare Aon</strong>, un grup de teste folosite de recrutori din toată lumea, prin care vi se verifică aptitudinile și disponibilitatea pentru o carieră viitoare.',
                freemium: {
                    description:
                        'Parcurgeți aceste teste pentru a vă măsura punctele forte și pentru a genera rapoarte eficiente cu privire la aptitudinile dvs.',
                    price: 'Gratuit',
                    numTests: '3 teste',
                    timeEstimated: 'aprox. 27 min',
                },
                premium: {
                    description:
                        'Acesta este <strong>testul suprem</strong>. Parcurgeți acest test 3-în-1 pentru a afla ce cariere ar trebui să urmați și veți primi un Raport complet al Candidatului. ',
                    numTests: 'test 3-în-1',
                    timeEstimated: 'aprox. 60 min',
                    sampleReport: '↓Descărcare Exemplu Raport',
                    candidateReport: 'Raport Candidat',
                    candidateReportDescription:
                        'Odată ce finalizați aceste teste, veți obține un Raport complet al Candidatului, cu o prezentare cuprinzătoare a rezultatelor dvs., inclusiv sfaturi despre îmbunătățirea setului de abilități personale, abilităților cărora ar trebui să le acordați atenție, cele mai bune oportunități de început, care ar trebui să fie următorii dvs. pași și altele.',
                },
            },
            section2: {
                title: 'Cum vă vor ajuta aceste teste să fiți angajat?',
                t1: 'Vă veți cunoaște <strong>aptitudinile</strong>',
                t2: 'Vă veți realiza <strong>potențialul</strong>',
                t3: 'Veți avea o idee clară despre ce <strong>carieră</strong> ar trebui să urmați',
                t4: 'Veți avea mai multă <strong>încredere</strong> în dvs.',
            },
            section3: {
                title: 'Aflați despre punctele dvs. personale forte și oportunitățile de carieră pentru a vă stimula dezvoltarea și progresul în carieră.',
            },
            section4: {
                title: 'Întreceți-vă chiar astăzi competitorii',
                description:
                    'prin completarea evaluărilor folosite de recrutori din întreaga lume în cadrul unor companii precum Deloitte, Siemens, Burger King, Vodafone sau P&G.',
            },
            section5: {
                title: 'Întrebări Frecvente',
                thisPage: 'această pagină',
                question01: {
                    q: 'Ce sunt Evaluările Aon?',
                    a: 'Evaluările recruților efectuate de către Aon sunt teste recunoscute la nivel global, care ajută companiile din întreaga lume să identifice cei mai buni candidați pentru un loc de muncă. Cu ajutorul evaluărilor recruților, recrutorii pot privi dincolo de CV-uri, note școlare, certificate de facultate și diplome universitare pentru a afla dacă un candidat li se potrivește.\n                <br><br>\n                Aceste soluții sunt în general rezervate în mod <strong>exclusiv recrutorilor</strong> – aici, veți primi o oportunitate <strong>exclusivă</strong> de a practica și de a obține rezultatele înainte de interviul dvs. de angajare. Majoritatea angajaților nu primesc această șansă, așa că profitați de ea!',
                },
                question02: {
                    q: 'Trebuie să plătesc pentru a accesa aceste evaluări?',
                    a: 'Puteți parcurge aceste 4 teste în mod gratuit – <i>Work-related Behavior</i>, <i>Numerical Reasoning</i>, <i>Deductive-logical Thinking</i>, și <i>Inductive-logical Reasoning</i>. Aceste teste vă măsoară calitățile și aptitudinile și sunt un mod grozav de a afla care vă sunt punctele forte și punctele slabe.\n\n                <br><br>Totuși, dacă doriți să obțineți o imagine de ansamblu completă asupra predispozițiilor dvs., să obțineți cunoștințe profesionale cu privire la calea cea mai potrivită în carieră și să faceți un pas uriaș către succesul dvs. viitor, puteți accesa, de asemenea, testul 3-în-1 și puteți obține un cuprinzător Raport al Candidatului pentru 79 EUR. <br><br>Pentru acces complet, pur și simplu <a href={premiumLink}>dați clic aici</a> și plătiți prin card – folosim o metodă de plată foarte sigură.\n                ',
                },
                question03: { q: 'De ce ar trebui să parcurg aceste teste?' },
                question04: {
                    q: 'Cum mă pot pregăti pentru aceste teste?',
                    a: 'Puteți citi totul despre cerințele tehnice și despre cum să vă pregătiți pentru evaluări pe <a href={link} target="_blank">această pagină</a>. Acolo veți găsi și materiale care vă vor ajuta să obțineți punctaj maxim',
                },
                question05: {
                    q: 'Unde altundeva pot găsi aceste evaluări?',
                    a: 'De obicei, s-ar putea să vi se solicite finalizarea acestor teste de către recrutorul dvs. - în afară de asta, nu le veți găsi disponibile în altă parte. Aceasta este o oportunitate exclusivă pentru dvs. de a practica, de a afla mai multe despre dvs. și despre viitoarea dvs. carieră.',
                },
                question06: {
                    q: 'De câte ori pot să parcurg testele?',
                    a: 'Primiți o singură încercare pentru fiecare test. Fără reluări! Asigurați-vă că aveți condiții confortabile pentru a profita de această oportunitate. Vă puteți familiariza cu testul urmărind videoclipuri cu screencast și făcând un exercițiu de practică înainte de efectuarea testul.',
                },
                question07: {
                    q: 'În ce limbă sunt aceste teste?',
                    a: '\n                Limba implicită pentru aceste teste este engleza, cu toate acestea, fiecare dintre ele are o varietate de limbi din care puteți alege. Puteți verifica ce limbi sunt disponibile și să alegeți limba care vi se potrivește cel mai bine înainte de a susține testul. \n                ',
                },
                question08: {
                    q: 'Există o dată de expirare pentru testele extinse după ce le plătesc?',
                    a: 'Nu! După ce plata dvs. este acceptată, puteți susține testele extinse oricând doriți. Acordați-vă timp pentru a pregăti și începe evaluările în momentul care vi se potrivește cel mai bine.',
                },
            },
        },
        center: {
            banner: {
                title: 'Verificați-vă progresul',
                subtitle: 'Iată o prezentare generală a progresului dvs. în evaluările carierei',
                moreInfo: 'Mai multe informații',
                yourProgress: 'Progresul dvs.',
                quote: 'Setarea idealurilor este primul pas prin care transformați invizibilul în vizibil',
            },
            list: {
                timeEstimated: 'aprox. {minutes} min',
                freemium: {
                    intro: '\n                    Acesta este primul pas în călătoria dvs. de dezvoltare personală! <br />\n                    Parcurgeți aceste teste pentru a vă măsura punctele forte și pentru a obține rapoarte eficiente asupra\n                    aptitudinilor dvs.\n                ',
                },
                premium: {
                    intro: '\n                    Acesta este testul suprem.<br />\n                    Parcurgeți aceste teste pentru a afla ce căi profesionale ar trebui să urmați și obțineți un\n                    cuprinzător <strong>Raport al Candidatului</strong>.\n                ',
                    description:
                        '\n                    <strong>Raportul Candidatului</strong> vă va oferi o prezentare\n                    cuprinzătoare a rezultatelor dvs., inclusiv <strong>sfaturi</strong> despre cum vă puteți îmbunătăți\n                    setul de aptitudini personale, asupra căror <strong>aptitudini</strong> ar trebui să vă îndreptați atenția, cele mai\n                    bune <strong>oportunități</strong> cu care puteți începe, care ar trebui să fie\n                    <strong>următorii dvs. pași</strong>, și multe altele.\n                ',
                },
            },
            instruments: {
                344: {
                    name: 'Deductive-logical Thinking',
                    description:
                        'Vedeți cât de bun sunteți la utilizarea cunoștințelor și aplicarea regulilor - acest test vă măsoară abilitățile analitice și de rezolvare a problemelor.',
                    estimatedTime: '9',
                },
                383: {
                    name: 'Inductive-logical Reasoning',
                    description:
                        'Cât de bine puteți identifica reguli și interacțiuni? Verificați cu acest test care vă măsoară abilitățile analitice și de rezolvare a problemelor.',
                    estimatedTime: '9',
                },
                390: {
                    name: 'Work-related Behavior',
                    description:
                        'Ce tip de trăsături de personalitate specifice angajaților aveți? Aflați parcurgând acest test care vă identifică caracteristicile de personalitate în ceea ce privește munca.',
                    estimatedTime: '30',
                },
                721: {
                    name: 'Numerical Reasoning',
                    description:
                        'Cât de bun sunteți în lucrul cu cifrele? Acest test măsoară înțelegerea informațiilor numerice și ajungerea la concluzii logice.',
                    estimatedTime: '9',
                },
                5392: {
                    name: 'Working Memory',
                    description:
                        'Cât de bine vă puteți concentra? Acest test măsoară capacitatea de a procesa și de a reține informații în medii care distrag atenția.',
                    estimatedTime: '15',
                },
                82013: {
                    name: 'flexTest',
                    description:
                        'Care sunt interesele dvs.? Acest chestionar vă va ajuta să determinați ce parcursuri profesionale ați putea urma.',
                    estimatedTime: '15',
                },
            },
        },
        dialog: {
            header: 'Începeți-vă evaluarea Aon',
            consent:
                'Înțeleg că Aon este responsabil pentru datele mele legate de această evaluare și sunt de acord cu termenii și condițiile acestora.\n                De asemenea, sunt de acord că Highered îmi poate transfera numele la Aon pentru a-mi genera raportul.',
            startTest: 'Începeți testul',
            consentErrorTitle: 'Eroare legată de consimțământ',
            consentErrorMessage:
                'A apărut o eroare la trimiterea consimțământului dvs. V-ați confirmat adresa de e-mail?',
        },
    },
    "<br><br>\\n           Premier - vous arrivez préparé avec une partie du processus de recrutement déjà effectuée, ce qui vous fera instantanément prendre de l'avance sur les autres candidats":
        {
            '\\n            <br><br>\\n Deuxième - vous abordez votre recrutement avec un esprit clair':
                {
                    " Vous connaissez vos points forts et ce que l'avenir vous réserve - motivation instantanée et véritable regain de confiance garantis! Les recruteurs pourront le dire":
                        {
                            '"': '\n               世界中のリクルーターが候補者の選択プロセスにおいてAONアセスメントテストを利用しています。事前にテストを受け、レポートを作成して提示すればリクルーターを驚かせることができるでしょう。どのように？\n                <br><br>\n                まず初めに、採用プロセスの一部をすでに終わらせているので、他の候補者よりも瞬時に優位に立つことができます。\n                <br><br>\n                次に、ご自身の強みやどんな将来が待ち受けているか把握しているため、明確な意思をもって採用活動に臨むことができます。瞬時にモチベーションを高め、確固とした自信がつくことを保証します。リクルーターはそれを見分けることができるのです',
                        },
                },
        },
    calendar: {
        header: 'Calendar',
        myCalendar: 'Calendarul Meu',
        noCalendar: 'Serviciile dvs. de carieră nu au încă activată funcția de calendar.',
        goBackBtn: 'Mergeți înapoi',
        calendarNotReady: 'Funcția "calendarul meu" nu este încă pregătită. Urmează în curând',
        noUpcomingAppointments: 'Nu aveți nici o programare viitoare.',
        appointmentMissing: 'Programarea nu este activă',
        appointmentNotActive:
            'Ne pare rău, ați încercat să vizualizați o programare care este inexistentă sau inactivă.',
        appointmentNotHavingAvailability:
            'Ne pare rău, această programare nu este disponibilă în acest moment. Reveniți mai târziu.',
        appointmentMissingRules: 'Programarea nu este disponibilă',
        needToCompleteProfile: 'Completați-vă profilul',
        noUpcomingAppointmentsPleaseBook:
            'Rezervați o programare pentru a vă debloca funcția calendar.',
        bookAppointment: 'Rezervați programare',
        bookAnotherAppointment: 'Rezervați o programare',
        attendedAppointments: 'Ați participat la programări',
        aboutAppointments: {
            header: 'Despre programări',
            button: 'Despre',
            block1: {
                header: 'Ce este o programare?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
            block2: {
                header: 'Pe cine pot contacta pentru a obține mai multe informații?',
                paragraph1:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
                paragraph2:
                    'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
            },
        },
        bookAnAppointment: 'Rezervați O Programare',
        backToCalendarBtn: 'Înapoi la calendar',
        backToBookingBtn: 'Înapoi la lista de programări',
        firstAvailable: 'Valabilitate inițială',
        loadingAppointment: 'Încărcare ...',
        bookModal: {
            title: 'Confirmați rezervarea',
            with: 'Cu',
            confirm: 'Confirmați',
            continue: 'Continuați',
            cancel: 'Închideți',
            first: {
                title: 'Aceasta este prima dvs. programare',
                description:
                    'Pentru a vă asigura că primiți invitația la eveniment, vă rugăm să confirmați că aveți acces la un calendar personal prin acest cont de e-mail',
                ok: 'OK',
                wrongEmail: 'E-mail greșit?',
            },
            changeEmail: {
                title: 'Selectați e-mail-ul de calendar',
                inputPlaceholder: 'Tastați e-mail-ul ...',
                ok: 'OK',
                back: 'Utilizați modul implicit',
            },
            unknownErrorHeader: 'A apărut o eroare la încercarea de rezervare',
            unknownErrorBody:
                'Vă rugăm să încercați să rezervați o altă dată, iar dacă acest lucru nu funcționează contactați departamentul de asistență.',
            confirmationHeader: 'Programarea dvs. este rezervată!',
            bookedTheFollowing: 'Detalii:',
            emailWillBeSent: 'Un e-mail va fi trimis către',
            withConfirmation: 'prin care vi se cere să vă confirmați participarea.',
        },
        dateDetailsModal: { title: 'Programări la' },
        completedYourProfile:
            'Trebuie să vă completați profilul pentru a avea acces la sistemul de calendar',
        toMyProfile: 'Editare profil',
    },
    chat: {
        profileSharingConfirmDialog: {
            title: '{name} dorește să vă vizualizeze profilul',
            content: 'Doriți să vă partajați profilul cu această persoană?',
            share: 'Partajare profil',
            reject: 'Nu',
        },
    },
    companyDetail: {
        locations: {
            header: 'Locații',
            viewAll: 'Vedeți toate',
            noLocations: 'Fără locații',
            allLocations: 'Toate locațiile',
        },
        jobModule: {
            header: 'Posturi de top',
            viewAllJobs: 'Vizualizați toate locurile de muncă de la {companyName}',
            noPositions: '{companyName} nu are în acest moment posturi disponibile la Highered.',
            defaultLabel: 'Posturi deschise',
        },
        videos: {
            header: 'Videoclipuri',
            noVideos: 'Fără videoclipuri',
            noMoreVideos: 'Nu mai există videoclipuri',
            moreVideosFrom: 'Mai multe videoclipuri de la {companyName}',
        },
        articles: {
            header: 'Articole',
            noArticles: 'Fără articole',
            noMoreArticles: 'Nu mai există articole',
            moreArticlesFrom: 'Mai multe articole de la {companyName}',
        },
    },
    components: {
        builders: {
            searchable: { create: 'Creați' },
            yearMonthPicker: { defaultSelect: 'Selectați o lună' },
            localeDropdown: {
                languages: { en: 'Engleză', cn: 'Chineză', fr: 'Franceză' },
            },
        },
        miscellaneous: {
            verifyModule: {
                title: 'Verificați-vă e-mail-ul academic',
                description:
                    'Este un proces rapid și vă va oferi acces la\n                            conținut exclusiv precum posturi unice, teste\n                            de aptitudini și resurse în carieră.',
                verificationPending: 'Se așteaptă verificarea',
                weHaveSentAnEmail:
                    ' Am trimis un e-mail la\n                                <strong>{studentEmail}</strong> pentru\n                                ca dvs. să vă puteți verifica. Asigurați-vă că\n                                ați verificat dosarul spam, deoarece multe școli sunt\n                                foarte stricte în privința e-mail-urilor primite.',
                verifyMe: 'Verifică-mă',
                resendVerifyEmail: 'Retrimitere e-mail de verificare',
                cancelVerification: 'Anulare verificare',
                emailSent: 'E-mail trimis',
                emailSentMessage:
                    'E-mail-ul a fost trimis cu succes. Dacă nu îl primiți, contactați-ne la support@highered.global.',
                resendErrorTitle: 'Eroare la retrimiterea e-mail-ului',
                resendErrorMessage:
                    'Nu s-a putut retrimite e-mail-ul de verificare. Vă rugăm să ne contactați la support@highered.global.',
                verificationCancelledTitle: 'Verificare anulată',
                verificationCancelledMessage: 'Verificarea a fost anulată cu succes.',
                cancelErrorTitle: 'Eroare în timpul anulării',
                cancelErrorMessage:
                    'Nu s-a putut anula verificarea. Vă rugăm să ne contactați la support@highered.global.',
            },
            verifyModuleDialog: {
                title: 'Verificați-vă e-mail-ul academic',
                university: 'Instituție Școlară',
                studentEmail: 'Adresa dvs. academică de e-mail',
                studentEmailPlaceholder: 'E-mail academic',
                message: 'Mesaj',
                verify: 'Verificați',
                sendRequest: 'Trimiteți solicitarea',
                verificationInProcess: 'În curs de verificare',
                emailHasBeenSentTo:
                    'Un e-mail a fost trimis la <strong>{email}</strong>. Urmați instrucțiunile primite pentru a verifica conexiunea dvs. cu <strong>{schoolName}</strong>',
                verificationRequestSentNonAcademic:
                    'Serviciile de carieră de la <strong>{schoolName}</strong> vor trebui să vă verifice conexiunea. Veți fi notificat prin e-mail atunci când acest lucru se va fi întâmplat.',
                ifNoEmailRecieved:
                    'Dacă nu ați primit e-mailul de verificare, vă rugăm să ne contactați.',
                contactHelp: 'Contactați-ne pentru asistență',
                doNotHaveAcademicEmail: 'Nu am o adresă de e-mail academică',
                doubleCheckEmail:
                    'Vă rugăm să verificați dacă această adresă de e-mail este corectă și dacă aveți acces la ea.',
                haveAcademicEmail: 'Am o adresă de e-mail academică',
                noAcademicEmailInfo:
                    'Dacă nu utilizați o adresă de e-mail academică, solicitarea dvs. va trebui aprobată manual de către serviciile de carieră. Prin urmare, trebuie să furnizați un mesaj scurt pentru a vă identifica.',
                alreadyVerifiedInfo: 'Sunteți deja verificat la această școală.',
            },
        },
        navigation: {
            navigation: {
                myPage: 'Pagina mea',
                jobs: 'Locuri de muncă',
                companies: 'Companii',
                masterclasses: 'Masterclass-uri',
                assessments: 'Evaluări',
                countryGuides: 'Ghiduri de țară',
                goToHaigui: 'Locuri de muncă în China',
                signIn: 'Autentificare / Înregistrare',
                vfairs: 'Evenimente Virtuale',
                events: 'Evenimente',
                newFeature: 'Opțiune Nouă!',
            },
            profileNavigation: { signOut: 'Deconectare' },
            sidebar: {
                myPage: 'Pagina mea',
                myProfile: 'Profilul meu',
                findJobs: 'Găsiți locuri de muncă',
                findCompanies: 'Găsiți companii',
                masterclasses: 'Masterclass-uri',
                assessments: 'Evaluări',
                countryGuides: 'Ghiduri de țară',
                goToHaigui: 'Locuri de muncă în China',
                virtualFairs: 'Evenimente Virtuale',
                logOut: 'Deconectare',
            },
            backToCalendar: 'Înapoi la calendar',
            allBooths: 'Toate chioșcurile',
            home: 'Acasă',
        },
        smart: {
            companyModule: {
                followJob: 'Adăugați la favorite',
                followCompany: 'Urmăriți compania',
                unFollowJob: 'Ștergeți de la favorite',
                unFollowCompany: 'Nu mai urmăriți compania',
                favoritedTitle: 'Salvată la favorite',
                favoritedMessage:
                    'Acest post a fost salvat în lista dvs. de favorite. Găsiți posturile dvs. favorite pe pagina mea.',
                unfavoritedTitle: 'Șters de la favorite',
                unfavoritedMessage: 'Acest post a fost eliminat din lista dvs. de favorite.',
                favoriteErrorTitle: 'Ceva nu a funcționat cum trebuie',
                favoriteErrorMessage: 'Nu s-a reușit adăugarea acestui post în lista de favorite',
                showAllCompanies: 'Afișează toate companiile',
                showOnlyCompaniesLiveOnChat: 'Afișează doar companiile care se află live pe chat',
            },
            profileModule: {
                profileCompletion: 'Completare profil',
                profileCompletionEncouragement:
                    'Prezentați-vă angajatorilor completând ultimele {percentLeft} rămase din profilul dvs.',
                gotoProfilePage: 'Actualizați profilul',
                profileCompleted: 'Profil completat',
                profileCompletedWhatsNext:
                    'Știați că majoritatea angajatorilor folosesc evaluări online în procesele lor de recrutare? Exersați acum și obțineți informații despre punctele dvs. tari și punctele dvs. slabe.',
                gotoTestsPage: 'Mergeți la centrul de evaluare',
                authIndication: {
                    title: 'Găsiți locul de muncă visat',
                    description:
                        'Doriți acces la funcții unice pentru școala dvs. și teste care vă vor ușura căutarea de locuri de muncă? Creați cu ușurință un utilizator cu Google, LinkedIn sau Facebook chiar acum.',
                    action: 'Să trecem la treabă',
                },
                toProfileHint: 'La profilul meu',
                toProfileUncompletedHint:
                    'Profilul dvs. nu este 100% complet. Vă rugăm să continuați completarea pentru a vă maximiza șansele de angajare.',
                profileActions: {
                    addFirstName: 'Adăugați prenumele',
                    addLastName: 'Adăugați numele de familie',
                    addNationality: 'Adăugați naționalitatea',
                    addPhoneNumber: 'Adăugați numărul de telefon',
                    addLanguage: 'Adăugați o limbă',
                    addEducation: 'Adăugați o formă de studii',
                    addEmail: 'Adăugați adresa de e-mail',
                    addGender: 'Adăugați sexul',
                },
            },
            featuredCompanies: { label: 'Companii Recomandate' },
            featuredPositions: { label: 'Posturi Recomandate' },
            featuredResource: {
                header: 'Alăturați-vă Conferinței Virtuale',
                cta: 'Vizionați acum!',
                wechatSignupHeader:
                    'Urmăriți funcția de WeChat a Highered pentru a primi actualizări',
            },
        },
    },
    '"': 'I-scan ang code ngayon!',
    cts: {
        filterNames: {
            employment_types: 'Tipuri de angajări',
            education_level: 'Niveluri de studii',
            job_category: 'Domenii',
            address: 'Locații',
            sector: 'Sectoare',
            exclude_school_id: 'Excludeți',
            languages: 'Limbi',
        },
        excludeSchoolIds: {
            '-1': 'Postări partajate',
            unknownSchoolId: 'Partener Școlar EFMD',
        },
        educationLevels: {
            BACHELORS_OR_EQUIVALENT: 'Licență',
            MASTERS_OR_EQUIVALENT: 'Masterat',
            DOCTORAL_OR_EQUIVALENT: 'PHD',
            MBA_OR_EQUIVALENT: 'MBA',
            DBA_OR_EQUIVALENT: 'DBA',
        },
        employmentTypes: {
            FULL_TIME: 'Normă întreagă',
            INTERN: 'Stagiu',
            TEMPORARY: 'Normă redusă',
            PART_TIME: 'Normă redusă',
        },
        startDate: 'Începere',
        educationFields: {
            ACCOUNTING_AND_FINANCE: 'Contabilitate și finanțe',
            ADMINISTRATIVE_AND_OFFICE: 'Administrativ și muncă de birou',
            ADVERTISING_AND_MARKETING: 'Publicitate și marketing',
            ART_FASHION_AND_DESIGN: 'Modă și design',
            BUSINESS_OPERATIONS: 'Operațiuni de afaceri',
            COMPUTER_AND_IT: 'Computere și IT',
            CUSTOMER_SERVICE: 'Serviciu clienți',
            EDUCATION: 'Educație',
            HEALTHCARE: 'Sănătate',
            HUMAN_RESOURCES: 'Resurse umane',
            INSTALLATION_MAINTENANCE_AND_REPAIR: 'Instalații, întreținere și reparații',
            LEGAL: 'Juridic',
            MANAGEMENT: 'Management',
            MANUFACTURING_AND_WAREHOUSE: 'Producție și depozite',
            MEDIA_COMMUNICATIONS_AND_WRITING: 'Comunicații media și jurnalism',
            OIL_GAS_AND_MINING: 'Energie',
            PROTECTIVE_SERVICES: 'Servicii de protecție',
            REAL_ESTATE: 'Imobiliare',
            SALES_AND_RETAIL: 'Vânzări și comerț',
            SCIENCE_AND_ENGINEERING: 'Știință și inginerie',
            SOCIAL_SERVICES_AND_NON_PROFIT: 'Servicii sociale și non profit',
            TRANSPORTATION_AND_LOGISTICS: 'Transport și logistică',
        },
        sectors: {
            Consulting: 'Consultanță',
            'Consumer Goods': 'Bunuri de larg consum',
            'Financial Services / Banking': 'Servicii financiare / Bănci',
            'Goverment / Public Administration / Non Profit':
                'Guvern / Administrație Publică / Non Profit',
            'International Trade & Development': 'Comerț Internațional & Dezvoltare',
            Manufacturing: 'Fabricație',
            'Media / Entertainment': 'Media / Divertisment',
            'Petroleum / Energy': 'Petrol / Energie',
            'Pharma / Healthcare / Biotech': 'Farmaceutic / Sănătate / Biotehnologie',
            'Real Estate / Construction / Infrastructure':
                'Imobiliare / Construcții / Infrastructură',
            'Technology (IT) / Telecom': 'Tehnologie (IT) / Telecomunicații',
            'Transportations & Logistics': 'Transport & logistică',
            Other: 'Altele',
        },
        countries: {
            'China (Hong Kong SAR)': 'Hong Kong',
            'Costa Rica': 'Costa Rica',
            'Europe & Sub-Saharan Africa': 'Europa & Africa Sub-Sahariană',
            'Hong Kong': 'Hong Kong',
            'Korea, South': 'Coreea de Sud',
            'New Zealand': 'Noua Zeelandă',
            'Papua-Ny Guinea': 'Papua Noua Guinee',
            'Puerto Rico': 'Puerto Rico',
            'Saudi Arabia': 'Arabia Saudită',
            'South Africa': 'Africa de Sud',
            'South Korea': 'Coreea de Sud',
            'Sri Lanka': 'Sri Lanka',
            'Taiwan (Province of China)': 'Taiwan',
            'The Seychell Islands': 'Seychelles',
            'United Arab Emirates': 'Emiratele Arabe Unite',
            'United Kingdom': 'Regatul Unit',
            'Ivory Coast': 'Coasta de Fildeș',
            Afghanistan: 'Afganistan',
            Algeria: 'Algeria',
            Angola: 'Angola',
            Argentina: 'Argentina',
            Armenia: 'Armenia',
            Australia: 'Australia',
            Austria: 'Austria',
            Azerbaijan: 'Azerbaijan',
            Bahamas: 'Bahamas',
            Bahrain: 'Bahrein',
            Bangladesh: 'Bangladesh',
            Belarus: 'Bielorusia',
            Belgium: 'Belgia',
            Botswana: 'Botswana',
            Brazil: 'Brazilia',
            Bulgaria: 'Bulgaria',
            Cambodia: 'Cambodgia',
            Canada: 'Canada',
            Chile: 'Chile',
            China: 'China',
            Colombia: 'Columbia',
            Congo: 'Congo',
            Croatia: 'Croația',
            Cyprus: 'Cipru',
            Czechia: 'Cehia',
            Denmark: 'Danemarca',
            Ecuador: 'Ecuador',
            Egypt: 'Egipt',
            Estonia: 'Estonia',
            Ethiopia: 'Ehtiopia',
            Fiji: 'Fiji',
            Finland: 'Finlanda',
            France: 'Franța',
            Germany: 'Germania',
            Ghana: 'Ghana',
            Greece: 'Grecia',
            Guernsey: 'Guernsey',
            Hungary: 'Ungaria',
            Iceland: 'Islanda',
            India: 'India',
            Indonesia: 'Indonezia',
            Iraq: 'Irak',
            Ireland: 'Irlanda',
            Israel: 'Israel',
            Italy: 'Italia',
            Japan: 'Japonia',
            Jersey: 'Jersey',
            Jordan: 'Iordan',
            Kazakhstan: 'Kazakhstan',
            Kenya: 'Kenya',
            Kuwait: 'Kuweit',
            Laos: 'Laos',
            Latvia: 'Letonia',
            Lebanon: 'Liban',
            Lithuania: 'Lituania',
            Luxembourg: 'Luxemburg',
            Malaysia: 'Malaezia',
            Malta: 'Malta',
            Mauritania: 'Mauritania',
            Mauritius: 'Mauritius',
            Mexico: 'Mexic',
            Mongolia: 'Mongolia',
            Morocco: 'Maroc',
            Myanmar: 'Myanmar',
            Namibia: 'Namibia',
            Netherlands: 'Țările de Jos',
            Nigeria: 'Nigeria',
            Norway: 'Norvegia',
            Oman: 'Oman',
            Pakistan: 'Pakistan',
            Panama: 'Panama',
            Paraguay: 'Paraguay',
            Peru: 'Peru',
            Philippines: 'Filipine',
            Poland: 'Polonia',
            Portugal: 'Portugalia',
            Qatar: 'Qatar',
            Romania: 'România',
            Russia: 'Rusia',
            Senegal: 'Senegal',
            Serbia: 'Serbia',
            Singapore: 'Singapore',
            Slovakia: 'Slovacia',
            Slovenia: 'Slovenia',
            Spain: 'Spania',
            Sudan: 'Sudan',
            Swaziland: 'Swaziland',
            Sweden: 'Suedia',
            Switzerland: 'Elveția',
            Syria: 'Siria',
            Taiwan: 'Taiwan',
            Tanzania: 'Tanzania',
            Thailand: 'Tailanda',
            Tonga: 'Tonga',
            Turkey: 'Turcia',
            Ukraina: 'Ucraina',
            Ukraine: 'Ucraina',
            USA: 'SUA',
            Uzbekistan: 'Uzbekistan',
            Vanuatu: 'Vanuatu',
            Vietnam: 'Vietnam',
            Zambia: 'Zambia',
        },
        languages: {
            Aceh: 'Aceh',
            Afrikaans: 'Afrikaans',
            Albanian: 'Albaneză',
            Amharic: 'Amharic',
            Arabic: 'Arabă',
            Arakanese: 'Arakanese',
            Armenian: 'Armeană',
            Azeri: 'Azeră',
            Badini: 'Badini',
            Basque: 'Bască',
            Belarusian: 'Bielorusă',
            Bengali: 'Bengaleză',
            Berber: 'Berber',
            Bosnian: 'Bosniacă',
            Bulgarian: 'Bulgară',
            Burmese: 'Burmeză',
            Cantonese: 'Cantoneză',
            Catalan: 'Catalană',
            Cebuano: 'Cebuano',
            Chechen: 'Chechen',
            Chin: 'Chin',
            Chinese: 'Chineză',
            Croatian: 'Croată',
            Czech: 'Cehă',
            Danish: 'Daneză',
            Dari: 'Dari',
            Dutch: 'Olandeză',
            English: 'Engleză',
            Estonian: 'Estoniană',
            Faroese: 'Faroese',
            Filipino: 'Filipineză',
            Finnish: 'Finlandeză',
            French: 'Franceză',
            German: 'Germană',
            Greek: 'Greacă',
            Greenlandic: 'Groenlandeză',
            Hausa: 'Hausa',
            Hebrew: 'Ebraică',
            Hindi: 'Hindi',
            Hungarian: 'Maghiară',
            Icelandic: 'Islandeză',
            Indonesian: 'Indoneziană',
            Italian: 'Italiană',
            Japanese: 'Japoneză',
            Kazakh: 'Kazahă',
            Kinyarwanda: 'Kinyarwanda',
            Kirundi: 'Kirundi',
            Korean: 'Coreeană',
            Kurdish: 'Kurdă',
            Kurmanji: 'Kurmanji',
            Kven: 'Kven',
            Latin: 'Latină',
            Latvian: 'Letonă',
            Lingala: 'Lingala',
            Lithuanian: 'Lituaniană',
            Macedonian: 'Macedoniană',
            Malagasy: 'Malagasy',
            Malaysian: 'Malaeziană',
            Mandarin: 'Mandarină',
            Mongolian: 'Mongolă',
            Nepali: 'Nepaleză',
            Norwegian: 'Norvegiană',
            Oromo: 'Oromo',
            Other: 'Altele',
            Panjabi: 'Panjabi',
            Pashto: 'Pashto',
            Persian: 'Persană',
            Polish: 'Poloneză',
            Portuguese: 'Portugheză',
            Punjabi: 'Punjabi',
            Romanes: 'Romanes',
            Romani: 'Rromă',
            Romanian: 'Română',
            Russian: 'Rusă',
            Sami: 'Sami',
            Serbian: 'Sârbească',
            Sign_language: 'Limbajul semnelor',
            Slovak: 'Slovacă',
            Slovene: 'Slovenă',
            Somali: 'Somaleză',
            Sorani: 'Sorani',
            Spanish: 'Spaniolă',
            Swahili: 'Swahili',
            Swedish: 'Suedeză',
            Tagalog: 'Tagalog',
            Tamil: 'Tamil',
            Thai: 'Tailandeză',
            Tigrinya: 'Tigrinya',
            Turkish: 'Turcă',
            Ukrainian: 'Ucrainiană',
            Urdu: 'Urdu',
            Uyghur: 'Uyghur',
            Vietnamese: 'Vietnameză',
            Wolof: 'Wolof',
        },
    },
    emailverification: {
        headerLabel: 'Verificare e-mail',
        verifyingEmail: 'Se verifică e-mail-ul',
        emailVerifySuccess: 'E-mail-ul dvs. a fost verificat!',
        emailVerifyFailure:
            'Ceva nu a funcționat cum trebuie... Încercați din nou sau contactați departamentul de asistență',
        gotoMyPage: 'Mergeți înapoj la Pagina Mea',
    },
    errors: {
        defaultErrorMessage: 'S-a produs o eroare!',
        logInErrorText: {
            invalidCredentials: 'Utilizator sau parolă nevalide',
            inactiveUser:
                'Utilizatorul cu e-mailul furnizat este inactiv. Verificați e-mailul pentru activarea contului sau încercați să vă resetați parola.',
            default: 'Nu s-a putut realiza autentificarea.',
        },
        registerErrorText: {
            passwordTooShort: 'Parola trebuie să aibă cel puțin 8 caractere lungime.',
            emailAlreadyInUse: 'E-mail-ul furnizat este folosit deja.',
            emailTaken:
                'Acest e-mail este deja folosit. Dacă v-ați folosit e-mailul școlar, acest lucru s-ar putea întâmpla deoarece ați avut un nume de utilizator înainte ca platforma să fie actualizată (la higheredtalent.org).',
            default: 'Nu s-a putut crea un utilizator.',
        },
        invalidTokenText: { default: 'Jetonul dvs. este nevalid sau a expirat.' },
        passwordErrorText: {
            passwordTooShort: 'Parola trebuie să aibă cel puțin 8 caractere lungime.',
            requireNonAlphanumeric: 'Parola trebuie să conțină cel puțin un caracter special.',
            requireLowerCase: 'Parola trebuie să conțină cel puțin o literă mică.',
            requireUpperCase: 'Parola trebuie să conțină cel puțin o literă mare.',
            requireUniqueChars: 'Parola trebuie să conțină cel puțin 6 caractere diferite.',
            default: 'Nu s-a putut realiza modificarea parolei',
        },
        recoverErrorText: {
            userNotFound:
                'Acest utilizator nu există! Vă rugăm să contactați departamentul de asistență.',
            userAlreadyActive:
                'Utilizatorul este deja activat!\nVă rugăm să încercați să vă conectați.',
            emailAlreadyInUse:
                'E-mailul furnizat este deja utilizat.\nDacă doriți să continuați cu activarea contului, încercați un e-mail diferit sau să vă autentificați cu un alt cont de social media. În caz contrar, accesați pagina de pornire și conectați-vă la contul dvs.',
            default: 'Nu s-a putut realiza activarea contului.\nVă rugăm să încercați mai târziu.',
        },
        socialAuthErrorText: {
            errorTitle: 'Nu s-a putut realiza autentificarea cu {provider}',
            invalidProviderGoogle:
                'Utilizatorul cu e-mailul furnizat nu este conectat la Google. Încercați, de exemplu, să vă conectați cu LinkedIn, Facebook sau prin e-mail.',
            invalidProviderFacebook:
                'Utilizatorul cu e-mailul furnizat nu este conectat la Facebook. Încercați, de exemplu, să vă conectați cu Google, LinkedIn sau prin e-mail.',
            invalidProviderLinkedIn:
                'Utilizatorul cu e-mailul furnizat nu este conectat la LinkedIn. Încercați, de exemplu, să vă conectați cu Google, Facebook sau prin e-mail.',
            invalidProviderWeChat:
                'Utilizatorul cu e-mailul furnizat nu este conectat la WeChat. Încercați, de exemplu, să vă conectați cu Google, Facebook sau prin e-mail.',
        },
        uniConnErrorText: {
            emailNotAvailable:
                'E-mailul pe care l-ați furnizat este deja utilizat. Acest lucru s-ar putea datora faptului că ați avut un nume de utilizator înainte ca platforma să fie actualizată (la higheredtalent.org). Vă rugăm să contactați departamentul de asistență.',
            invalidEmailDomain:
                'Domeniul de e-mail furnizat nu se potrivește cu universitatea furnizată. Vă rugăm să alegeți universitatea corectă.',
            existingConnection: 'Utilizatorul este deja conectat la universitatea furnizată',
            default: 'Nu s-a putut iniția verificarea.',
        },
        spotlightErrors: {
            userUpdate: {
                emailAlreadyInUse: 'E-mail-ul este deja folosit.',
                default: 'Nu s-a putut realiza actualizarea',
            },
        },
    },
    favorites: {
        header: 'Favoritele mele',
        active: 'Active',
        expired: 'Expirate',
        expiresThisMonth: 'Termen limită aplicație în această lună',
        expiresThisWeek: 'Termen limită aplicație în această săptămână',
        expiresLater: 'Termen limită mai târziu',
        noActiveFavorites: 'Nu aveți posturi favorite active',
        noExpired: 'Nu aveți posturi favorite expirate',
    },
    findcompanies: {
        headerLabel: 'Găsiți companii',
        companyListLabel: 'Companii',
    },
    findjobs: {
        header: 'Găsiți locuri de muncă',
        changeFilters: 'Modificați filtrele',
        recruitmentModule: {
            body: 'Sunteți ofițer de recrutare, profesionist pe partea de carieră sau sunteți doar\n        interesat să recrutați din rândul studenților?',
            createJob: 'Faceți clic aici pentru a crea un loc de muncă',
        },
    },
    general: {
        documentTitle: 'Platformă de Oportunitate Globală',
        email: 'E-mail',
        password: 'Parolă',
        confirmPassword: 'Confirmați parola',
        loading: 'În curs de încărcare',
        ok: 'OK',
        save: 'Salvați',
        add: 'Adăugați',
        close: 'Închideți',
        delete: 'Ștergeți',
        cancel: 'Anulați',
        done: 'Finalizat',
        continue: 'Continuați',
        back: 'Înapoi',
        next: 'Următorul',
        finish: 'Finalizare',
        success: 'Succes',
        error: 'Eroare',
        description: 'Descriere',
        months: {
            0: 'Ian',
            1: 'Feb',
            2: 'Mar',
            3: 'Apr',
            4: 'Mai',
            5: 'Iun',
            6: 'Iul',
            7: 'Aug',
            8: 'Sep',
            9: 'Oct',
            10: 'Nov',
            11: 'Dec',
        },
        days: {
            0: 'Dum',
            1: 'Lun',
            2: 'Mar',
            3: 'Mie',
            4: 'Joi',
            5: 'Vin',
            6: 'Sâm',
        },
        dialogs: {
            helperTexts: {
                checkHasPendingAction: 'Se analizează verificarea în așteptare',
                verifySchoolConnection:
                    'Verificați conexiunea școlii pentru a accesa aceste resurse',
                logInToAccessMoreFeatures: 'Mii de Oportunități Internaționale de Carieră ',
            },
        },
        minutesShort: 'min',
        poweredBy: 'Cu Sprijinul',
    },
    gptw: {
        company: {
            alt: 'GPTW',
            tooltip: 'Această companie este o companie certificată „Great Place To Work”',
        },
        posting: {
            label: {
                alt: 'GPTW',
                tooltip:
                    'Această postare apaține unei companii certificate ca „Great Place To Work”',
            },
            detail: {
                alt: 'GPTW',
                tooltip: {
                    isCertified: '{companyName} este certificată ca „Great Place To Work”',
                    description:
                        'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                    readMore: 'Faceți clic pentru a citi mai multe',
                },
            },
        },
    },
    jobdetail: {
        detailModule: {
            deadline: 'Termen limită aplicație',
            location: 'Locație',
            employmentType: 'Tip de angajare',
            languageRequirements: 'Cerințe referitoare la limbă',
            workPermitRequirements: 'Cerințe referitoare la permisele de muncă',
            preferredEducationField: 'Preferințe referitoare la domeniul de educație',
            preferredEducationLevel: 'Preferințe referitoare la nivelul de educație',
            jobTags: 'Etichete',
            apply: 'Aplicați acum',
            verificationRequired:
                'Trebuie să vă verificați adresa de e-mail a școlii pentru a aplica.',
            verificationRequiredHint:
                'Trebuie să vă verificați adresa de e-mail a școlii pentru a aplica',
            verificationPending: 'Aveți o verificare în așteptare la această școală',
            verificationPendingHint: 'Aveți o verificare în așteptare la această școală',
        },
        invalidJobAd: {
            caption:
                'Ne pare rău, dar nu am putut găsi acest post. Dacă credeți că aceasta este o eroare, vă rugăm să contactați departamentul de asistență utilizând caseta de chat de mai jos.',
            btn: 'Găsiți alte locuri de muncă',
        },
    },
    mypage: {
        header: 'Pagina mea',
        suggestedPositions: 'Posturi sugerate',
        favoriteModule: {
            header: 'Posturile mele favorite',
            seeAll: 'Vedeți toate',
            noFavorites: 'Nu aveți posturi favorite active',
        },
    },
    recoverpassword: {
        createPassword: 'Creați o nouă parolă',
        newPasswordLabel: 'Parola nouă',
        newPasswordPlaceholder: 'Parolă',
        confirmPasswordLabel: 'Confirmați parola',
        confirmPasswordPlaceholder: 'Confirmați parola',
        resetPasswordButton: 'Resetați parola',
        resettingPassword: 'Parolă în curs de resetare',
        passwordsNotMatching: 'Parolele nu se potrivesc.',
    },
    recoveruser: {
        headerLabel: 'Recuperați utilizator Highered',
        accountActivation: 'Activare cont',
        step1: {
            header: 'Bine ați venit pe noua noastră platformă!',
            subHeader: 'Alegeți modul în care doriți să vă conectați contul',
            description:
                'Pentru un proces de conectare mai simplu, vă recomandăm să vă conectați contul la cel puțin unul dintre următoarele servicii.',
            OR: 'sau',
            emailAndPassword: 'Folosiți propriul e-mail',
        },
        step2: {
            header: 'Folosiți e-mail-ul și parola',
            description:
                'Acesta este e-mailul principal care va fi asociat contului dvs. Vă recomandăm să utilizați un e-mail diferit de adresa universității dvs. pentru a vă păstra accesul la datele dvs. după absolvire. Puteți controla cu ușurință ce e-mailuri primiți de la noi în setările contului dvs.',
            invalidEmail: 'E-mail-ul furnizat nu este un e-mail valid.',
            passwordsNotMatch: 'Parolele trebuie să se potrivească',
            passwordDescription01:
                'Pentru a vă asigura securitatea contului, trebuie să setați o nouă parolă. Vă rugăm să creați o parolă care să conțină următoarele:',
            passwordDescription02: 'Minimum 8 caractere',
            passwordDescription03: 'Cel puțin o literă mică (a-z)',
            passwordDescription04: 'Cel puțin o literă mare (A-Z))',
            passwordDescription05: 'Cel puțin un număr sau un simbol special (0-9, !#$ etc.)',
            passwordDescription06: 'Cel puțin 6 caractere unice',
            repeatPassword: 'Repetați parola',
        },
        step3: {
            header: 'Se activează utilizatorul',
            loadingHints: {
                0: 'Se încarcă informațiile utilizatorului',
                1: 'Se pregătește totul pentru dvs.',
                2: 'Noi posibilități se află chiar după colț',
                3: 'Aproape gata!',
            },
            successHeader: 'Contul dvs. este acum pregătit!',
            successSubheader: 'Acum puteți accesa funcții exclusive!',
            errorHeader: 'Nu s-a putut realiza activarea contului',
            ifWrongContact:
                'Dacă considerați că acest lucru este greșit, vă rugăm să contactați departamentul de asistență',
            contactForHelp: 'Contactați-ne pentru asistență',
            goBack: 'Mergeți înapoi',
        },
    },
    resourcesInternal: {
        header: 'Resurse',
        resourceTypeHeader: 'Tip',
        resourceNoContent: 'Școala dvs. nu a activat încă funcția resurse.',
        resourceFolderNoContent: 'Nu există resurse disponibile în acest dosar.',
        resourceTitleHeader: 'Titlu',
        resourcePublishDateHeader: 'Publicat',
        searchPlaceholder: 'Căutați după nume sau cuvânt cheie ...',
        cvTemplateHeader: 'ȘABLON CV HIGHERED (OPTIMIZAT ATS)',
        cvTemplateSubtitle: 'Descărcați aici!',
    },
    shared: {
        userNavSection: {
            myPage: 'Pagina mea',
            myProfile: 'Profilul meu',
            myTests: 'Evaluări',
            myApplications: 'Aplicații',
            myFavorites: 'Favorite',
            resources: 'Resurse',
            calendar: 'Calendar',
            documents: 'Încărcare CV',
        },
        searchModule: {
            searchBar: { label: 'Căutați după titlu sau cuvinte cheie' },
            filters: { clearFilters: 'Ștergeți filtrele' },
            filterLimit: {
                title: 'S-a atins limita de filtre',
                message: 'Nu mai pot fi selectate filtre de acest tip',
            },
        },
        postingModule: {
            postingModule: {
                positions: 'Posturi',
                estimatedCount: 'ca {count} din {totalCount}',
                knownCount: '{count} din {totalCount}',
                noMatchFound: 'Nu s-a găsit nimic potrivit căutării dvs.',
            },
            postItem: { applyBefore: 'Termen limită aplicație' },
            postCard: { deadline: 'Termen limită' },
        },
        loginModule: {
            emailVerificationTip:
                'Este posibil să dureze câteva minute pentru a ajunge la căsuța de e-mail.',
            noEmail: 'Nici un e-mail? Vă rugăm să verificați dosarul spam sau:',
            logIn: 'Autentificare',
            socialAuthBtns: {
                continueWithFacebook: 'Continuați cu Facebook',
                continueWithGoogle: 'Continuați cu Google',
                continueWithLinkedIn: 'Continuați cu LinkedIn',
                continueWithWeChat: 'Continuați cu WeChat',
            },
            verifyEmail: {
                verifyYourEmail: 'Vă rugăm să vă verificați e-mail-ul',
                weSentAnEmailTo: 'Am trimis un e-mail de verificare la',
                continueToSignIn: 'Continuați la autentificare',
                resendEmail: 'Retrimitere link de verificare',
                newEmailSent: 'Noul e-mail a fost trimis',
            },
            registerForm: {
                recommendation:
                    'Vă rugăm să folosiți e-mail-ul personal și nu\n            e-mail-ul școlii pentru a vă asigura că aveți acces la informațiile dvs. după\n            absolvire.',
                register: 'Înregistrare',
                passwordsNotMatch: 'Parolele nu se potrivesc',
            },
            logInPaper: {
                useEmail: 'sau folosiți e-mail-ul dvs.',
                noAccount: 'Nu aveți un cont?',
                signUp: 'Înregistrați-vă',
                logInToAccess: 'Autentificați-vă pentru a avea acces la această funcție',
                showAllOptions: 'Afișează toate opțiunile de autentificare',
                hideAllOptions: 'Afișează mai puține',
            },
            logInForm: {
                logIn: 'Autentificare',
                forgotPassword: 'Ați uitat parola?',
            },
            forgotPassword: {
                title: 'Solicitați resetarea parolei',
                description:
                    'Nu vă faceți griji - toată lumea își uită parola din când în când.\n                Introduceți e-mail-ul mai jos pentru a vă reseta parola',
                resetPassword: 'Resetați parola',
                emailSentTitle: 'Asistența este în drum spre dvs.!',
                emailHasBeenSent:
                    'Un e-mail a fost trimis la\n                            <br>\n                            <strong>{email}</strong>\n                            <br>\n                            conținând instrucțiuni despre cum să vă resetați parola. Vă rugăm să vă verificați\n                            mesajele.',
                noEmail: 'Nici un e-mail?',
                sendEmailOneMoreTime: 'Trimite e-mail-ul din nou',
                resendErrorTitle: 'Eroare la recuperarea parolei',
                resendErrorMessage:
                    'Nu s-a putut trimite e-mail-ul de recuperare a parolei. Poate ați introdus un e-mail greșit?',
            },
        },
        termsAndConds: {
            termsAndConditions: 'Termeni & Condiții',
            privacyPolicy: 'Politica de confidențialitate',
            talentPanel: 'Școală/Angajator?',
        },
        favoriteModule: {
            favoriteCard: {
                deleted: 'Șters',
                deletedTitle: 'Acest post nu mai este disponibil',
            },
        },
        pageNotFound: {
            header: '404',
            description: 'Se pare că pagina pe care o căutați nu mai există.',
            goToHome: 'Mergeți la pagina principală',
            contactus: 'Contactați-ne',
        },
        chat: {
            liveNow: 'Live pe chat acum!',
            seeAll: 'Toate',
            schoolSpecificChats: 'Acces rapid',
            help: 'Aveți nevoie de ajutor?',
            chatExistsLabel: 'Chat-ul există',
        },
        countdown: {
            day: 'zi',
            days: 'zile',
            hour: 'oră',
            hours: 'ore',
            minute: 'minut',
            minutes: 'minute',
            second: 'secundă',
            seconds: 'secunde',
        },
    },
    spotlight: {
        header: 'Profilul meu',
        saveChangesToSubmit: 'Salvați-vă profilul pentru ca modificările să intre în vigoare',
        saveChanges: 'Salvați modificările',
        saveSuccessful: 'Modificările dvs. au fost salvate cu succes',
        personalDetails: {
            header: 'Detalii personale',
            firstName: 'Prenume',
            lastName: 'Nume de familie',
            nationality: 'Naționalitate',
            gender: 'Sex',
            uploadProfileImage: 'Încărcare fotografie',
            genderOptions: {
                male: 'Masculin',
                female: 'Feminin',
                other: 'Altul',
                none: 'Prefer să nu spun',
                unknown: 'Necunoscut',
            },
            wrongFileTypeErrorHeader: 'Fișier de tip nevalid',
            wrongFileTypeErrorDescription: 'Puteți încărca doar imagini',
        },
        summary: { header: 'Rezumat' },
        contactDetails: {
            header: 'Detalii de contact',
            contactEmail: 'E-mail de contact',
            phoneNumberHeader: 'Număr de telefon mobil',
            countryCode: 'Codul țării',
            phoneNumber: 'Număr de telefon',
            invalidEmail: 'E-mail-ul tastat nu este un e-mail valid.',
            permanentEmail:
                'NOTĂ: Această modificare este permanentă. Vă puteți seta e-mail-ul o singură dată.',
        },
        languages: {
            header: 'Limbi',
            languageLabel: 'Limbă',
            levelLabel: 'Nivel',
            addLanguage: 'Adăugați o limbă nouă',
            proficiencies: {
                '22f882cc-3cb0-4cfd-a590-ef010f4d798b': 'Competență elementară',
                '82edcac6-693b-42ea-bf24-0a52774f395c': 'Competență de lucru limitată',
                'a97f6798-7280-4ce7-8896-6d4a8fb58c63': 'Competență de lucru profesională',
                '93b37709-3f2d-4853-ac77-b8c0dd07243e': 'Competență profesională completă',
                '250d296e-d6db-46fb-8c44-07950db80ec4': 'Competență nativă sau bilingvă',
            },
        },
        education: {
            header: 'Educație',
            addEducation: 'Adăugați o educație',
            notGraduated: 'Încă nu am absolvit',
            graduatedIn: 'Am absolvit la {date}',
            dialog: {
                addNewEducation: 'Adăugați o nouă educație',
                degreeTitle: 'Program',
                institution: 'Instituție',
                degreeType: 'Nivel de studii',
                fieldOfStudy: 'Domeniul de Studiu',
                cannotFindField: 'Nu găsesc domeniul',
                studyStart: 'Luna de începere',
                studyEnd: 'Luna de absolvire',
                invalidDegreeTitle: 'Trebuie să completați un titlu al programului.',
                invalidSchool: 'Trebuie să selectați o școală.',
                invalidStartDate: 'Vă rugăm să selectați data de începere.',
                invalidEndDate: 'Vă rugăm să selectați data de absolvire.',
                invalidStudyPeriod: 'Nu puteți absolvi înainte de data de începere.',
                invalidDegreeField: 'Vă rugăm să introduceți un domeniu de studiu valid.',
                invalidDegreeLevel: 'Vă rugăm să introduceți un nivel de studii valid.',
                selectStartDate: 'Data de începere',
                selectEndDate: 'Data de absolvire',
                degrees: {
                    '5b468395-7bf7-4f14-88d9-32096884d4ef': 'Licență',
                    '09f419fa-1517-41ce-970c-df0d073fc440': 'Masterat',
                    '2c917ed6-5bb7-4e23-95ab-60c55d8df135': 'MBA',
                    '1fff1451-f07c-415c-954a-63b1e5f44fc8': 'DBA',
                    '2fbd6155-d939-40cc-970d-283be0aef433': 'PHD',
                },
                diciplins: {
                    '383c2086-24da-4fe2-977b-7e3d4da85f8e': 'Agricultură & Silvicultură',
                    'c8fb1348-bdac-4ed3-af7a-a831376d04b7': 'Științe Aplicate & Profesii',
                    '5c665d94-5124-4226-a4f6-da8cca47e3f6': 'Artă, Design & Arhitectură',
                    '06b028e2-d7ed-4281-8668-1009d6da1c35': 'Afaceri & Management',
                    '747624bb-0174-4961-a3c0-dbe4f1cb750d': 'Informatică & IT',
                    'ede2bbdb-7a1d-466c-99e5-bcab52e07d69': 'Economie',
                    '5c0432d4-9297-429a-85c4-3305d207764e': 'Educație & Instruire',
                    '8198b6ea-5b28-4be2-afbc-45df759c65cb': 'Inginerie & Tehnologie',
                    '7e5c0527-d1ec-4125-945e-138ec473e8dd':
                        'Studii de Mediu & Științe ale Pământului',
                    '3babe28b-6285-4a03-b0b8-43f55be393cd': 'Ospitalitate, Timp Liber & Sport',
                    '9eebcc51-385e-4122-88a1-6dd3efbaf896': 'Științe Umaniste',
                    '390cf111-b55a-4bb7-a6b6-1cc2b21a248f': 'Jurnalism & Media',
                    'a2744908-9521-4330-a07d-3680b058d0a6': 'Drept',
                    '947993e1-b723-4d85-8cd9-a4ae46cd623e': 'Marketing',
                    'c98802c8-74a5-4a98-99ba-84eb76fd1a60': 'Master în Inovare și Afaceri',
                    'bca263cc-3d17-4ad8-b70e-e2bfe04421fa': 'Master în Managementul Dezvoltării',
                    'a37667e2-5713-4157-82e9-78c10760d2de': 'Master în Știința Datelor',
                    '72277bb7-9d5e-422a-a2b4-8a8fb8be7143': 'Medicină și Sănătate',
                    'bd84a8cd-ce66-4c61-86a8-7fcb6644cc5d': 'MS în Finanțe',
                    '9e665ac9-9611-4508-af4b-22e91f167ea4':
                        'MS în Studii Internaționale de Afaceri',
                    'baf5bb0a-d0ab-4c13-aacc-c6a8a90e2fcf': 'MS în Analize de Afaceri',
                    '7d832109-642a-4730-aada-26927eb683ee': 'MS în Management',
                    'baf05a5a-faba-4f30-9254-9cd73bb63bbf': 'Științele Naturii & Matematică',
                    '828cc4ac-1f2b-4133-8e29-ba1347585ae6': 'Științe Sociale',
                    '44c1f8cf-8696-4638-bc03-9763c2de32af': 'Altele',
                },
            },
        },
        workAuthorization: {
            header: 'Autorizație de Muncă',
            addWorkAuthorization: 'Adăugați o autorizație de muncă',
            implicitValue: 'În baza naționalității dvs.',
            dialog: {
                selectCountry: 'Selectați țara',
                addEuWorkAuthorization: 'Adăugați o autorizație de muncă din UE',
            },
        },
        communication: {
            header: 'Comunicare',
            sendMeUpdatesDescription:
                'Vă rog să-mi trimiteți prin e-mail știri despre carieră, posturi și actualizări ale companiei',
        },
        errors: {
            imageUpload: {
                title: 'Nu s-a putut încărca imaginea.',
                message: 'Imaginea este prea mare!',
            },
        },
        exitDialog: {
            title: 'Modificările nesalvate vor fi pierdute',
            message:
                'Încercați să ieșiți din pagină fără a salva modificările. Doriți să vă salvați profilul înainte de a trece mai departe?',
            stayAction: 'Rămâneți pe pagină',
            saveAction: 'Salvați profilul',
            continueAction: 'Continuați fără a salva',
        },
    },
    tests: {
        header: 'Teste',
        unauthorized:
            'Testele sunt în prezent în versiune beta închisă. Nu aveți încă acces la aceste funcții. Vor fi disponibile în curând!',
        error: 'Ceva nu a funcționat când am încercat să încărcăm testele. Vă rugăm să încercați din nou mai târziu.',
        assessmentModule: { header: 'Evaluarea dvs.' },
        completedYourProfile:
            'Trebuie să vă completați profilul pentru a avea acces la această evaluare',
        toMyProfile: 'Editați-vă profilul',
    },
    vfair: {
        header: 'Evenimente Virtuale EFMD',
        activeNow: 'În curs de desfășurare',
        visibilityPrivate: 'Privat',
        visibilityNetwork: 'Rețea',
        visibilityOpen: 'Deschis',
        interested: 'Înregistrare',
        attend: 'Participați la eveniment',
        enterEvent: 'Accesați evenimentul virtual',
        notinterested: 'Nu mă mai interesează',
        shownInterest: 'Înregistrat',
        signUpToday: 'Înscrieți-vă astăzi!',
        vfairsInfo:
            'Conectați-vă cu companii și organizații din întreaga lume, într-un mediu sofisticat de simulare a unui loc de muncă care permite interacțiunea în timp real între recrutori și candidați. Faceți clic pe evenimentul virtual care vă interesează și înscrieți-vă pentru a primi notificări.',
        recruitingOrgs: 'Companii & Organizații Angajatoare',
        preRegistered: 'Pre-înregistrat',
        prepareForTheFair: 'Pregătiți-vă pentru evenimentul virtual',
        privateVFairHeader: 'Campus eveniment virtual',
        privateVFairMessage:
            'Acest eveniment virtual este găzduit pe o platformă școlară EFMD și, prin urmare, nu poate fi accesat de aici.',
        schoolNotJoinedNetworkEventMessage:
            'Școala dvs. nu s-a înscris încă la acest eveniment virtual, contactați directorul de program sau departamentul de cariere pentru a solicita participarea.',
        companyNotJoinedNetworkEventMessage:
            'Organizația dvs. nu are un chioșc virtual activ la acest eveniment. Contactați Highered pentru a cere participarea.',
        pavilions: 'Pavilioane',
        general: 'General',
        allCompanies: 'Toate companiile',
        lobby: 'Foaier',
        inviteCode: 'Cod de invitație',
        eventRequiresInvitation: 'Acest eveniment necesită o invitație',
        haveCode: 'Am un cod',
        checkCode: 'Verificați codul',
        invalidCode: 'Cod nevalid',
        registeredSuccessfully: 'Înregistrat cu succes',
        pavilionTabs: {
            home: 'acasă',
            companies: 'companii',
            articles: 'articole',
            jobs: 'locuri de muncă',
            events: 'evenimente',
        },
        events: {
            noEventsAvailable: 'Nu există evenimente disponibile',
            showCompleted: 'Afișare finalizate',
            hideCompleted: 'Ascundere finalizate',
            liveNow: 'Live acum',
            joinTheEvent: 'Alăturați-vă evenimentului',
            addToCalendar: 'Adăugați la calendar',
        },
        links: {
            masterclasses: {
                header: 'Masterclass-uri',
                buttonCaption: 'Vizionați Masterclass-urile',
                description:
                    'Vizualizați o gamă largă de masterclass-uri de calitate superioară, incluzând „CV Optimization to Get Hired”, „Rock Your Linkedin Profile” și „Salary Negotiation”, printre multe altele, pentru toate etapele carierei dvs.!',
            },
            detailsmasterclass: { header: 'Participați la Masterclass' },
            cv: {
                header: 'Șablon CV',
                buttonCaption: 'Descărcați Șablon CV',
                description:
                    'Accesați șablonul CV optimizat pentru ATS, pentru a impresiona în mod profesional și optim recrutorii.',
            },
            elevatorPitch: {
                header: 'Provocarea Elevator Pitch',
                buttonCaption: 'Trimiteți prezentarea dvs.',
                description:
                    'Participați la „Provocarea Pitch Perfect”! Aceasta este oportunitatea dvs. de a vă prezenta valoarea către sute de recrutori de la companii și organizații de top la nivel mondial!',
            },
        },
        footerHeaders: {
            social: 'Urmăriți-ne pentru mai multe actualizări',
            sponsored: 'Sponsorizat de',
            organized: 'Organizat de',
        },
        educationPopup: {
            step00: {
                header: 'Împărtășiți-vă educația',
                subtitle:
                    'Pentru a continua, oferiți angajatorilor mai multe informații despre dvs.',
                continueLabel: 'Adăugare educație',
                leaveLabel: 'Revocare',
            },
            step01: { header: 'Spuneți-ne despre educația dvs.' },
            step02: { loadingLabel: 'Așteptați un moment...' },
            step03: {
                header: 'Educație completă',
                subtitle:
                    'Acum puteți să vă partajați profilul și să fiți mai interesant în rândul angajatorilor',
                continueLabel: 'Continuați să explorați evenimentul virtual',
            },
            error: {
                header: 'Hopa! S-a produs o eroare!',
                subtitle:
                    'Nu am putut stoca informațiile dvs. educaționale. Vă rugăm să încercați din nou mai târziu.',
            },
        },
    },
};
